<template>
  <div style="height: 252px;" v-loading="loading">
    <div class="flex card-line" v-for="(line,index) in cardOption" :key="index">
      <app-dashboard-sale-instant-card
          v-for="(card,key) in line"
          :key="key"
          :data="card"
      ></app-dashboard-sale-instant-card>
    </div>
  </div>
</template>

<script>
import AppDashboardSaleInstantCard from "@/views/modules/home/components/sale/components/dashboard-sale-instant-card";
import {mapGetters} from "vuex";
import {getTodaySaleBoard} from "@/api/dashboard";
import {defaultShow} from "@/filters";
import {dashboardMixin, queryMixin} from "@/minxins";
import {isMeaningful, isMeaningless} from "@/utils/common";

export default {
  name: "sale-board",
  mixins: [queryMixin, dashboardMixin],
  components:{AppDashboardSaleInstantCard},
  data() {
    return {
      loading: false,
      cardOption: [
        {
          Sales: {title: '销售额',help:'除已取消的订单总量*售价'},
          SaleQuantity: {title: '销量',help:'除已取消的订单中的商品总量'},
          OrderQuantity: {title: '订单量',help:'除已取消的订单总量'}
        },
        {
          CustomerPrice: {title: '平均单价',help:'销售额/销量'},
          RefundQuantity: {title: '退款量'},
          GrossProfitRate: {title: '销售毛利率'}
        }
      ],
      // 今日、今日已付款、今日未付款、昨日、上周同日、上月同日、去年同日
      typeOption: ['today', 'payToday', 'noPayToday', 'yesterday', 'lastWeek', 'lastMonth', 'lastYear']
    }
  },
  methods: {
    $gjQuery() {
      if(!this.showStoreMask){
        return;
      }
      // 缓存了时区时，第一次不请求
      if(isMeaningful(this.timezoneId)&&isMeaningless(this.timezoneText)){
        return
      }
      this.loading = true;
      const params = {
        dateTime: this.timezoneText,
        currency: this.dashboardCurrency,
        countrys: this.countryMarket.countryIds,// 国家
        marketIds: this.countryMarket.marketIds,// 店铺
      };
      getTodaySaleBoard(params).then((data) => {
        this.cardOption.forEach(line => {
          for (let card in line) {
            this.$set(line[card],'currencySymbol',data.currencySymbol)
            this.typeOption.forEach(type => {
              this.$set(line[card],type,data[type + card])
            })
          }
        })
      }).complete(() => {
        this.loading = false;
      })
    },
    defaultShow
  }
}
</script>

<style scoped lang="scss">
.card-line+.card-line{
  margin-top: 12px;
}
</style>